export const STATSIG_EVENT_NAMES = {
    CHECKOUT_STEP_ORDER_SUCCESS:
        'Checkout - Checkout Step - Success - Place Order',
    CHECKOUT_STEP_PAGE_VIEW: 'Checkout - Checkout Step - View - Page',
    CHECKOUT_STEP_PAYMENT_SELECTION_CLICK:
        'Checkout - Checkout Step - Click - Payment Selection',
    CHECKOUT_STEP_PLACE_ORDER_CLICK:
        'Checkout - Checkout Step - Click - Place Order',
    LOGIN_STEP_PAGE_VIEW: 'Checkout - Login Step - View - Page',
    LOGIN_STEP_SUCCESS_LOGIN: 'Checkout - Login Step - Success - Button Login',
};
